import React from "react";

const Markup = ({ renderField, renderSelect, Button, ...props }) => {
    const { name, regionIds } = props;

    return (
        <>
            {renderField(name)}
            {renderSelect(regionIds)}
            {!!Button && <Button />}
        </>
    );
};
export default Markup;
